import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { GuaranteeAsidePanelComponent } from "./guarantee-aside-panel.component";
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { MatSlideToggleModule } from '@angular/material';
import { TooltipDirectiveModule } from '@toro/common/shared/directives/tooltip/tooltip.module';
import { AlertboxComponent } from './components/alertbox/alertbox.component';
import { PositionComponent } from './components/position/position.component';
import { DisclaimerBoxComponent } from './components/disclaimerbox/disclaimerbox.component';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        SvgIconModule,
        MatSlideToggleModule,
        CommonModule,
        RouterModule,
        TooltipDirectiveModule,
    ],
    declarations: [
        GuaranteeAsidePanelComponent,
        AlertboxComponent,
        PositionComponent,
        DisclaimerBoxComponent
    ],
    exports: [
        GuaranteeAsidePanelComponent
    ],
    entryComponents: [
        GuaranteeAsidePanelComponent
    ],
    providers: [
    ],
})
export class GuaranteeAsidePanelModule { }
